import { Component } from '@angular/core';

@Component({
  selector: 'app-mobile-coming-soon',
  templateUrl: './mobile-coming-soon.component.html',
  styleUrls: ['./mobile-coming-soon.component.scss'],
  standalone: false,
})
export class MobileComingSoonComponent {
  buildTranslationKey(relativeKey: string): string {
    return `mobile.comingSoon.${relativeKey}`;
  }
}
